module.exports = __webpack_public_path__ + "img/c03_unitchampionchampion_Normal_ua.6a4fa994.webp";